import React from 'react';

const Features = () => {
    return (
        <div className='features__container'>
            <div className='features__circle-yellow'></div>
            <div className='features__dots'>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            <div className="features__dots_dot"></div>
            </div>
            <div className="features__facilities">Facilities</div>
            <div className="features__header">The advantages that we provide</div>
            <div className="features__blocks">
                <div className="features__blocks_row">
                <div className="features__block">
                    <div className="features__block_image first"></div>
                    <div className="features__block_header">Engaging Community</div>
                    <div className="features__block_description">Phasellus suspendisse non, convallis quam aliquet volutpat. Netus cras quam orc.</div>
                </div>
                <div className="features__block">
                    <div className="features__block_image second"></div>
                    <div className="features__block_header">Premium Facilities</div>
                    <div className="features__block_description">Diam eu, mauris, in amet viverra. Eget ut scelerisque eget nibh ut quis.</div>
                </div>
                <div className="features__block">
                    <div className="features__block_image third"></div>
                    <div className="features__block_header">Affordable Price</div>
                    <div className="features__block_description">Velit, rutrum a cursus eleifend egestas.</div>
                 </div>
                    </div>
                <div className="features__blocks_row">
                <div className="features__block">
                    <div className="features__block_image fourth"></div>
                    <div className="features__block_header">Workspace Personalization</div>
                    <div className="features__block_description">Ornare tempor morbi tempor nibh est a in.</div>
                </div><div className="features__block">
                    <div className="features__block_image fifth"></div>
                    <div className="features__block_header">24/7 Access</div>
                    <div className="features__block_description">Tellus rhoncus enim nisl et lorem in sed. Congue nunc est habitant quam lectus neque.</div>
                </div><div className="features__block">
                    <div className="features__block_image sixth"></div>
                    <div className="features__block_header">Clean Environment</div>
                    <div className="features__block_description">Pretium sodales vitae id gravida tempor. Erat adipiscing orci turpis fames nunc, id diam.</div>
                </div>
                </div>
            </div>
        </div>
    );
};

export default Features;